(() => {
  'use strict';
  const NS = window.RSLRentalPhase3 = window.RSLRentalPhase3 || {};
  const money = (value) => new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR'}).format(Number(value)||0);
  const parseDate = value => { if(!value) return null; const d=new Date(value+'T12:00:00'); return Number.isNaN(d.getTime())?null:d; };
  const daysBetween = (a,b) => Math.max(1, Math.round((b-a)/86400000)+1);
  const factorForDays = days => days<=1?1:days<=2?1.5:days===3?2:days===4?2.4:days<=7?3.2:Math.ceil(days/7)*3.2;
  function getPeriod(){
    let start='', end='';
    try { const saved=JSON.parse(localStorage.getItem('rslRentalPeriod')||'{}'); start=saved.start||saved.startDate||''; end=saved.end||saved.endDate||''; } catch(e){}
    const s=document.querySelector('[data-rslr-quick-start], [data-rslr-period-start]');
    const e=document.querySelector('[data-rslr-quick-end], [data-rslr-period-end]');
    return {start:(s&&s.value)||start,end:(e&&e.value)||end};
  }
  function updateEstimate(root){
    const box=root.querySelector('[data-rslr-phase3-estimate]'); if(!box) return;
    const day=Number(root.dataset.rslrDay||0), priceOnRequest=root.dataset.rslrPriceRequest==='true';
    const p=getPeriod(), a=parseDate(p.start), b=parseDate(p.end);
    const strong=box.querySelector('strong'), note=box.querySelector('span'), label=box.querySelector('small');
    if(priceOnRequest||day<=0){ box.dataset.state='missing'; label.textContent='Prijsindicatie'; strong.textContent='Prijs wordt gecontroleerd'; note.textContent='RSL bevestigt prijs en beschikbaarheid na je aanvraag.'; return; }
    if(!a||!b||b<a){ box.dataset.state='missing'; label.textContent='Gekozen periode'; strong.textContent='Kies start en retour'; note.textContent='Daarna tonen we direct een indicatieve huurprijs excl. btw.'; return; }
    const days=daysBetween(a,b), factor=factorForDays(days), total=day*factor;
    box.dataset.state='ready'; label.textContent=days+' huurdag'+(days===1?'':'en')+' · factor '+String(factor).replace('.',',')+'×'; strong.textContent=money(total)+' excl. btw'; note.textContent='Indicatie per stuk. Beschikbaarheid, borg, transport en service worden door RSL bevestigd.';
  }
  function init(){
    document.querySelectorAll('[data-rslr-phase3-product]').forEach(root=>{
      updateEstimate(root);
      root.addEventListener('change',e=>{ if(e.target.matches('input[type="date"]')) setTimeout(()=>updateEstimate(root),0); });
    });
  }
  document.addEventListener('rslr:period-change',()=>document.querySelectorAll('[data-rslr-phase3-product]').forEach(updateEstimate));
  document.addEventListener('DOMContentLoaded',init); NS.refresh=init;
})();
